import AppIcon from '../icons/AppIcon'
import { cx } from '../util/cx'
import styles from './OptionList.module.css'

export interface OptionItem {
  title: string
  description: string
  icon?: string
  tone?: 'default' | 'accent' | 'muted'
  onClick?: () => void
  href?: string
}

interface OptionListProps {
  options: OptionItem[]
}

export default function OptionList({ options }: OptionListProps) {
  return (
    <ul className={styles.list}>
      {options.map((option) => {
        const cardClass = cx(
          styles.card,
          option.tone === 'accent' && styles.cardAccent,
          option.tone === 'muted' && styles.cardMuted,
        )
        const iconClass = cx(
          styles.icon,
          option.tone === 'accent' && styles.iconAccent,
          option.tone === 'muted' && styles.iconMuted,
        )

        const content = (
          <>
            {option.icon && (
              <span className={iconClass} aria-hidden>
                <AppIcon icon={option.icon} size={22} />
              </span>
            )}
            <span className={styles.body}>
              <h2 className={styles.title}>{option.title}</h2>
              <p className={styles.description}>{option.description}</p>
            </span>
            <AppIcon icon="mdi:chevron-right" size={22} className={styles.chevron} />
          </>
        )

        return (
          <li key={option.title}>
            {option.href ? (
              <a className={cardClass} href={option.href}>
                {content}
              </a>
            ) : (
              <button type="button" className={cardClass} onClick={option.onClick}>
                {content}
              </button>
            )}
          </li>
        )
      })}
    </ul>
  )
}
